<template>
  <ul class="tabpanel">
    <!-- 0:课程介绍 1:课程目录 2:课程评价 -->
    <li :class="`${data_index === 0 ? 'active' : ''} img`">
      <img v-if="data_videoInfo.detail" :src="data_videoInfo.detail" alt="" />
      <p v-else>
        <Empty :description="presentation_empty_null_text" />
      </p>
    </li>
    <!--  1:课程目录  -->
    <li :class="data_index === 1 ? 'active' : ''">
      <dl v-if="data_videoInfo.normalCourseVideos && data_videoInfo.normalCourseVideos.length" class="courseList">
        <dd v-for="(item, index) in data_videoInfo.normalCourseVideos"
          :class="data_vid && (data_vid === item.video.vid) ? 'active' : ''" :key="index" @click="data_payVideo(item)">
          <div class="courseInfo">
            <h5>{{ item.video.name }}</h5>
            <div v-if="item.video.speakerList.length || item.video.vid">
              <span v-for="(user, index) in item.video.speakerList" @click.stop="toPersonal(user)" :key="index"
                :class="user.systemUserId ? 'active' : ''">{{ user.name }}</span>
              <i v-if="item.video.vid">时长：{{ videoDuration(item.video.duration) }}</i>
            </div>
          </div>
          <CourseListType :data_videoInfo="data_videoInfo" :item="item"/>
        </dd>
      </dl>
      <Empty v-else class="courseListNull" :description="catalogue_empty_null_text" />
    </li>
    <!--  2:课程评价  -->
    <li :class="data_index === 2 ? 'active' : ''">
      <div class="score">
        <span>{{ data_videoInfo.score }}<i>分</i></span>
        <a-rate disabled v-model:value="score" allow-half />
        <div class="setScore" v-if="data_isScore_b">评分</div>
      </div>

      <!-- 回复 -->
      <a-comment class="comment-list">
        <template #avatar>
          <!--          头像-->
          <!--          <a-avatar-->
          <!--            :size="36"-->
          <!--            :src="userHead"-->
          <!--            alt="Han Solo"-->
          <!--          />-->
        </template>
        <!-- 输入框 -->
        <template #content>
          <!--          <a-form-item>-->
          <a-textarea v-model:value="comment_input" :rows="3" :disabled="false"
            :placeholder="comment_input_placeholder" />
          <!--          </a-form-item>-->
          <!--          <a-form-item>-->
          <a-button class="commentSubmit" html-type="submit" :loading="submitting" type="primary" @click="handleSubmit">
            发送
          </a-button>
          <!--          </a-form-item>-->
        </template>
      </a-comment>

      <!-- 评论列表 -->
      <a-list class="comment-list" :data-source="comment_b.list">
        <template #renderItem="{ item, index }">
          <a-list-item>
            <CommentModule :data_comment="item" :data_reply_fn="reply_fn" :data_index="index" :data_like_fn="like" />
          </a-list-item>
        </template>
      </a-list>
      <!-- 分页 -->
      <div class="page">
        <a-pagination :total="comment_b.totalCount" @change="onPageChange" :hideOnSinglePage="true"
          v-model:current="comment_b.current" :default-current="comment_b.defaultCurrent" />
      </div>
    </li>
  </ul>
  <!-- 评分弹窗 -->
  <Modal v-model:data_isShow="scoreModel">
    <div class="setScore">
      <a-rate disabled v-model:value="setScoreValue" allow-half />
    </div>
  </Modal>
</template>

<script>
import moment from "moment";
import "moment/locale/zh-cn";
import { Rate, Comment, button, Input, avatar, list, Pagination, Empty, message } from "ant-design-vue";
import CommentModule from "@c/course/Comment";
import CourseListType from "@c/course/CourseListType";
import Modal from "@c/Modal";
import { videoDuration, syslogin, getUserId } from "@/utils/methods.js";
import { getCourseCommentPage, saveComment, commentDigg } from "@/api";
export default {
  name: "tabpanel",
  components: {
    [Rate.name]: Rate,
    [list.name]: list,
    [list.Item.name]: list.Item,
    [Comment.name]: Comment,
    [button.name]: button,
    [avatar.name]: avatar,
    [Input.TextArea.name]: Input.TextArea,
    [Pagination.name]: Pagination,
    Empty,
    CommentModule,
    CourseListType,
    Modal,
  },
  props: [
    "data_index",
    "data_videoInfo",
    "data_payVideo",
    "data_vid",
    "data_isScore_b",
    "data_userId",
  ],
  computed: {
    // 根据 秒 转成 分钟：秒
    videoDuration () {
      return (second) => {
        return videoDuration(second);
      };
    },
  },
  data () {
    return {
      userId: getUserId(),
      presentation_empty_null_text: '暂无介绍',
      catalogue_empty_null_text: '暂无课程',
      score: 0, // 课程评分
      userHead: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',// 登录者头像
      scoreModel: false, // 评分弹窗
      setScoreValue: 0, // 用户设置评分
      comment_b: { // 评论页数
        list: [], // 评论列表
        pageSize: 10, // 每页条数
        defaultCurrent: 1, // 默认页数
        current: 1, // 当前页数
        totalCount: 0,// 总页数
      },
      submitting: false, // 发送等待动画
      comment_input: "", // 发送的评论的内容
      comment_input_placeholder: this.$props.data_userId ? "请输入内容..." : "请先登录...", // 发送的评论提示
      video_index_active: -1, // 选中的视频
      commentParentId: "", // 父评论id
      default_avatar: require('../../assets/img/default_avatar.png'), // 默认头像
      courseId: this.$route.query.courseId ? this.$route.query.courseId : this.$route.params.videoId
    };
  },
  methods: {
    // 个人中心
    toPersonal (item) {
      if (item.systemUserId) {
        let href = '/user-center?profileUserId=' + item.systemUserId
        window.open(href, '_blank');
      }
    },
    // 喜欢 type:like/dislike
    like (type, commentId) {
      // 判断是否登录
      if (!this.$props.data_userId) {
        syslogin();
      }
      commentDigg({
        commentId: commentId,
        diggerId: this.$props.data_userId,
      }).then(res => {
        if (res.code === 1) {
          if (type === 'liked') {
            // 喜欢-》不喜欢
            this.comment_b.list.map(v => {
              if (v.id === commentId) {
                v.action = 'dislike'
                v.likes--;
              }
            })
          } else if (type === 'dislike') {
            // 不喜欢-》喜欢
            this.comment_b.list.map(v => {
              if (v.id === commentId) {
                v.action = 'liked';
                v.likes++;
              }
            })
          }
        }
      })
    },
    // 发送评论
    handleSubmit () {
      // 判断是否登录
      if (!this.$props.data_userId) {
        syslogin();
      }
      // 判断有没有@xxx 回复父评论
      let context = this.comment_input.replace(/^\@[\s\S]*\s/, '');

      if (!context) {
        message.info('请输入评论内容！');
        return;
      }
      this.submitting = true;

      saveComment({
        content: context, // 内容
        courseId: this.courseId, // 课程id
        commentatorId: this.$props.data_userId, // 用户id
        parentId: this.commentParentId, // 子评论的父id
      }).then((res) => {
        if (res.code === 1) {
          message.info(res.msg);
          this.getCourseCommentPage_fn();
          this.comment_input = ""; // 清空输入框
          this.commentParentId = ""; // 清空父id
        }
      });
    },
    // 回复评论
    reply_fn (item) {
      this.comment_input = "@" + item.author + " ";
      this.commentParentId = item.id;
    },
    // 分页器分页
    onPageChange (current, pageSize) {
      this.comment_b.current = current;
      this.getCourseCommentPage_fn();
    },
    // 获取评论
    getCourseCommentPage_fn (current) {
      getCourseCommentPage({
        courseId: this.courseId, // 课程id
        pageNo: this.comment_b.current,
        pageSize: this.comment_b.pageSize,
        userId: this.$props.data_userId,
      }).then((res) => {
        if (res.data.code === 1) {
          this.submitting = false; // 关闭发送等待动画
          let commentList_dom = []; // 评论合集
          res.data.list.map((v) => {
            let children_data = []; // 子评论
            v.childComments.map((j) => {
              children_data.push({
                author: j.child,
                content: j.text,
                avatar: j.avatarAddress ? j.avatarAddress : this.default_avatar,
                datetime: '',
                id: j.id,
              })
            })
            commentList_dom.push({
              author: v.commentator.realName,
              avatar: v.commentator.avatarAddress ? v.commentator.avatarAddress : this.default_avatar,
              content: v.content,
              datetime: moment(v.commentTime),
              action: v.isDigg === "T" ? "liked" : "disliked",
              likes: v.diggs,
              id: v.id,
              children: children_data,
            });
          });
          this.comment_b.list = commentList_dom;
          this.comment_b.totalCount = res.data.page.totalCount;
          this.comment_b.current = res.data.page.pageNo;
        }
      });
    },
  },
  mounted () {
    this.getCourseCommentPage_fn();
  },
  watch: {
    data_videoInfo: {
      handler (n, o) {
        this.score = n.score / 2;
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.tabpanel {
  margin-right: 20px;
  width: 786px;
  border-radius: 6px;
  flex: 0 0 auto;

  &>li {
    display: none;
    background: #fff;
    border-radius: 6px;
    overflow: hidden;

    &.active {
      display: block;
    }

    &.img {
      @extend %defaultBg;
      width: 100%;

      &>img {
        width: 100%;
      }

      &>p {
        margin: 60px 0;
      }
    }
  }
}

/* 课程列表dl */
.courseListNull {
  margin: 60px 0;
}

.courseList {
  padding: 30px 20px 15px;

  dd {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex: 1;
    padding-bottom: 15px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 15px;

    &.active {

      & .courseInfo *,
      & :deep(.coursePlay i) {
        color: $theme_blue !important;
        cursor: pointer;
      }
    }

    .courseInfo {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-right: 10px;

      h5 {
        font-size: 18px;

      }

      div {
        font-size: 14px;
        margin-top: 10px;

        span {
          color: #666666;
          margin-right: 20px;

          &.active {
            color: #0581ce;
          }
        }

        i {
          color: #646464;
        }
      }
    }
  }
}

/* 评分 */
.score {
  padding: 20px 20px 0;
  display: flex;
  align-items: center;

  span {
    color: #eb8e4c;
    font-size: 24px;
    margin-right: 12px;

    i {
      font-size: 18px;
    }
  }

  .setScore {
    display: inline-block;
    background: $theme_blue;
    border-radius: 6px;
    padding: 0 14px;
    line-height: 30px;
    color: #fff;
    margin-left: auto;
    cursor: pointer;
  }
}

/* 评论两侧边距************ */
.comment-list {
  padding: 0 20px;
}

/* 评论头像大小 */
:deep(.ant-comment-avatar img) {
  width: 100%;
  height: 100%;
}

:deep(.ant-list-item) {
  padding: 0;
}

/* 发送评论按钮 */
.commentSubmit {
  margin-top: 20px;
}

.page {
  text-align: center;
}
</style>
